export function listen(element, type, handler) {
  element.addEventListener(type, handler);
  return function() {
    element.removeEventListener(type, handler);
  };
}

function initElevateZoom(viewport){
  if (viewport!='xs'){

    // Clear all before (re)init
    $('.zoomContainer, .zoomWindowContainer').remove();

    var zoomImgContainer = $('#zoom-img-container');
    var zoomOptions = {cursor:'crosshair', borderSize:1, borderColour:'#eee', lensBorderSize:0, lensFadeIn:100, lensFadeOut:100,
      zoomWindowFadeIn:100, zoomWindowFadeOut:100, tintColour:'#FFF', zoomTintFadeIn:100, zoomTintFadeOut:100,
      zoomWindowPosition:'zoom-img-container', zoomWindowWidth:zoomImgContainer.width(), zoomWindowHeight:zoomImgContainer.height() };

    // elevateZoom initalised for each of the images in the carousel
    $('.carousel-inner .item>img').elevateZoom(zoomOptions);
  }
}

function initPhotoSwipe(){
  var carouselItems = $('#js-carousel').find('.item');
  var parseThumbnailElements = function() {
      var items=[], itemImg, itemImgSrc, swipeObj, i;

      for(i=0; i<carouselItems.length; i++) {
        itemImg = $(carouselItems[i]).find('img');
        itemImgSrc = itemImg.attr('src');
        swipeObj = { src:itemImgSrc, w:(typeof(IMAGE_WIDTH)!='undefined' ?IMAGE_WIDTH :500), h:(typeof(IMAGE_HEIGHT)!='undefined' ?IMAGE_HEIGHT :500), title:itemImg.attr('alt'), msrc:itemImgSrc };
        items.push(swipeObj);
      }
      return items;
    },
    openPhotoSwipe = function(index){
      var pswpElement = document.querySelectorAll('.pswp')[0],
        items = parseThumbnailElements(),
        options = {index:index,closeOnScroll:false},
        gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
      gallery.init();
    },
    onThumbnailsClick = function(element) {
      var index = $(element).closest('.item').index();
      openPhotoSwipe(index);
      return false;
    };

  $.each(carouselItems, function (index, carouselItem) {
    $(carouselItem).on('click', function () {
      onThumbnailsClick($(this));
    });
  });
}

export function zoom() {
  $('#js-carousel').on('slide.bs.carousel', function (e) {
    $(e.relatedTarget).find('img').trigger('unveil');
  }).find('.item:first-of-type img').trigger('unveil');

  if (typeof(IMAGE_ZOOM)=='undefined' || IMAGE_ZOOM=='elevatezoom') {

    (function($, document, window, viewport) {
      $(document).ready(function() {
        initElevateZoom(viewport.current());
      });
      $(window).resize(
        viewport.changed(function() {
          initElevateZoom(viewport.current());
        })
      );
    })(jQuery, document, window, ResponsiveBootstrapToolkit);
  } else {
    if (typeof initPhotoSwipe == 'function') {
      $('#js-carousel').addClass('photoswipe');
      initPhotoSwipe();
    }
  }
}

export function changeCountry(form, callbackfn) {
  $('#country, #d_country').on('change', function() {
    $.post(form.data('session-form-url'), form.serialize(), function(data) {
      callbackfn(form);
    });
  });
}

export function lazyLoadImages() {
  $('.image img').each(function(){
    var $img = $(this),
      origSrc = $img.attr('src');

    $img.unveil(400,function(){
      // revert back to default if img doesnt exist
      $img.on('error',function(){
        $img.off('error');
        $img.attr('src',origSrc);
      });
    });
  });
}

var reform;
$('body').on('submit', 'form:has(.g-recaptcha)', function (e) {
  e.preventDefault();
  reform = this;
  var widgetID = $(reform).data('render-id');
  if (widgetID) {
    grecaptcha.reset(widgetID);
    grecaptcha.execute(widgetID);
  } else {
    grecaptcha.reset();
    grecaptcha.execute();
  }
});
export function onSubmit(token) {
  reform.submit();
}
